import { FORM_ACTIONS } from './formValidation'
import { get as getPipe } from '../utils/sigpipe'

export default {
  name: 'input-file',

  ui: {
    input: 'input[type="file"]',
    selection: '[js-input-file-selection]',
  },

  events: [
    {
      on: 'change',
      target: 'input',
      handle (e) {
        let fileName = ''
        if (this.ui.input.files && this.ui.input.files.length > 1) {
          fileName = (this.ui.input.getAttribute('data-multiple-caption') || '').replace('{count}', this.ui.input.files.length)
          console.log(this.ui.input.files)
          this.ui.input.files.forEach(el => {
            console.log(el)
          })
        } else {
          fileName = this.ui.input.value.split('\\').pop()
        }
        if (fileName) this.ui.selection.innerText = fileName
        else this.ui.selection.innerText = ''
      },
    },
  ],

  componentDidMount () {
    if (this.formId) return
    this.formId = this.el.closest('form').getAttribute('data-form-id')
    if (this.formId) {
      this.pipe = getPipe(this.formId)
      if (this.pipe) {
        this.pipe.on(({ action, formData }) => {
          // formData = { methode: 7, token: process.env.NEWSLETTER_TOKEN, ...formDataNew }
          switch (action) {
            case FORM_ACTIONS.SUCCESS: {
              this.ui.input.value = null
              this.ui.selection.innerText = ''
              break
            }
          }
        })
      }
    }
  },
}
